import { Component } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';

@Component({
  templateUrl: './terms.html',
  styleUrls: ['./terms.css'],
})

export class TermsPage {
  constructor(
  ) {}
}
